import { render, staticRenderFns } from "./VPlayer.vue?vue&type=template&id=666b79e3&"
import script from "./VPlayer.vue?vue&type=script&lang=ts&"
export * from "./VPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports